/**
 * Quote line totals: quantity × unit price for the selected kit type (young or adult).
 */

export function parseQuantity(quantity) {
  const q = parseInt(String(quantity), 10);
  return Number.isFinite(q) && q > 0 ? q : 1;
}

export function resolveKitType(kitType, size) {
  if (kitType === 'young' || kitType === 'adult') return kitType;
  const s = String(size || '').toLowerCase();
  if (/youth|young|junior|kids|child|xs\b|s\b/.test(s)) return 'young';
  return 'adult';
}

export function calculateQuotePricing({
  quantity,
  youngKitPrice,
  adultKitPrice,
  kitType,
  size,
  fallbackPrice = 29.99
}) {
  const qty = parseQuantity(quantity);
  const fallback = parseFloat(fallbackPrice) || 29.99;
  const young = parseFloat(youngKitPrice);
  const adult = parseFloat(adultKitPrice);
  const resolvedYoung = young > 0 ? young : fallback;
  const resolvedAdult = adult > 0 ? adult : fallback;
  const type = resolveKitType(kitType, size);
  const unitPrice = type === 'young' ? resolvedYoung : resolvedAdult;
  const totalAmount = Math.round(unitPrice * qty * 100) / 100;

  return {
    quantity: qty,
    kit_type: type,
    kit_type_label: type === 'young' ? 'Young / Youth' : 'Adult',
    unit_price: unitPrice,
    young_kit_price: resolvedYoung,
    adult_kit_price: resolvedAdult,
    young_kit_total: type === 'young' ? totalAmount : null,
    adult_kit_total: type === 'adult' ? totalAmount : null,
    total_amount: totalAmount,
    kit_price: unitPrice
  };
}
